
import { insigniaApi } from "../../api/moduloResultados/insigniaApi"
import { companiasApi } from "../../api/companiasApi"
import { eventosApi } from "../../api/eventosApi"
import { retosApi } from "../../api/moduloResultados/retosApi"
import { premiosApi } from "../../api/moduloResultados/premiosApi"
import { tiposRetosApi } from "../../api/moduloResultados/tiposRetosApi"
import { tiposActividadesApi } from "../../api/moduloResultados/tiposActividadesApi"
import { ramosApi } from "../../api/moduloResultados/ramosApi"
import { nivelApi } from "../../api/moduloResultados/nivelApi"
import { equivalenciasApi } from "../../api/equivalenciasApi"
import { productividadApi } from "../../api/moduloResultados/productividadApi"
import { tiendaProductosApi } from "../../api/moduloResultados/tiendaProductosApi"
import { retoActividadesApi } from "../../api/moduloResultados/retoActividadesApi"
import { progresoRetoApi } from "../../api/moduloResultados/progresoRetoApi"
import { nivelActividadApi } from "../../api/moduloResultados/nivelActividadApi"
import { progresoNivelApi } from "../../api/moduloResultados/progresoNivelApi"
import { caminoApi } from "../../api/moduloResultados/caminoApi"
import { historialEquivalenciasApi } from "./historialEquivalenciasApi"
import { historialProgresoApi } from "./historialProgresoApi"

  export const ResultadosApis = {
    insigniaApi,
    companiasApi,
    eventosApi,
    premiosApi,
    tiposRetosApi,
    ramosApi,
    nivelApi,
    tiposActividadesApi,
    retosApi,
    equivalenciasApi,
    productividadApi,
    tiendaProductosApi,
    retoActividadesApi,
    progresoRetoApi,
    nivelActividadApi,
    progresoNivelApi,
    caminoApi,
    historialEquivalenciasApi,
    historialProgresoApi
}

